import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

export type ProjectProperties = { title?: string; emoji?: string; color?: string };
export type ProjectCreationSource = "planner-sidebar" | "project-list";

export class CreateProjectEvent extends AmplitudeEvent {
    constructor(props: { numProjects: number; source: ProjectCreationSource } & ProjectProperties) {
        super("create_project");
        this.props = props;
    }
}

export class UpdateProjectTitleEvent extends AmplitudeEvent {
    constructor() {
        super("update_project_title");
    }
}

export class UpdateProjectDescriptionEvent extends AmplitudeEvent {
    constructor() {
        super("update_project_description");
    }
}

export class UpdateProjectStartDateEvent extends AmplitudeEvent {
    constructor() {
        super("update_project_start_date");
    }
}

export class UpdateProjectEndDateEvent extends AmplitudeEvent {
    constructor() {
        super("update_project_end_date");
    }
}

export class UpdateProjectStatusEvent extends AmplitudeEvent {
    constructor(oldStatus: string, newStatus: string) {
        super("update_project_status");
        this.props = { oldStatus, newStatus };
    }
}

export class UpdateProjectEmojiEvent extends AmplitudeEvent {
    constructor() {
        super("update_project_emoji");
    }
}

export class UpdateProjectColorEvent extends AmplitudeEvent {
    constructor() {
        super("update_project_color");
    }
}
